Card = require 'app/scripts/models/card'
CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'

class CardList extends CollectionWithHelpers
  model: Card
  initialize: (models, options) ->
    @listenTo @, 'change:pos', @sort
    @list = options.list
    return

  url: '/1/cards'

  comparator: (card) -> card.get('pos') || 0

module.exports = CardList
